import { render, staticRenderFns } from "./GradeSalary.vue?vue&type=template&id=da0043d6&scoped=true&"
import script from "./GradeSalary.vue?vue&type=script&lang=js&"
export * from "./GradeSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0043d6",
  null
  
)

export default component.exports